import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import RightModalLayout from '../../layouts/Modal/RightModalLayout';
import ButtonMC from '../../components/ButtonMC';
import TitleMC from '../../components/TitleMC';
import { SIDEBAR_ACTIONS } from '../../../constants/actionsConstants';
import customHistory from '../../../customHistory';
import IconMC from '../../components/IconMC';

const MessagingRuleUpgradeModal = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { retailer_info } = useSelector((state) => state.retailerUsersReducer) || {};

  const close = () => {
    dispatch({
      type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR,
      payload: { componentKey: 'MessagingRuleUpgradeModal' }
    });
  };

  const goToPlans = () => {
    close();
    if (retailer_info?.chargebee_plan_id || retailer_info?.chargebee_subscription_id) {
      customHistory.push(
        `/retailers/${retailer_info?.slug}/plans/${retailer_info?.chargebee_plan_id}`
      );
    } else {
      customHistory.push(`/retailers/${retailer_info?.slug}/plans`);
    }
  };

  return (
    <RightModalLayout title={t('messaging_rules.upgrade_modal.configure')}>
      <div className="tw-m-6 tw-border tw-border-gray-200 tw-rounded-xl tw-p-6 tw-flex tw-flex-col tw-items-center tw-gap-4">
        <div className="tw-flex tw-items-center tw-justify-center tw-bg-yellow-100 tw-rounded-full tw-p-3">
          <IconMC name="lock-outline" className="tw-text-4xl tw-text-yellow-500" />
        </div>
        <TitleMC
          textClassName="tw-w-full tw-text-center tw-text-base"
          text={t('messaging_rules.upgrade_modal.title')}
          variant="H1_SEMIBOLD"
        />
        <p className="tw-text-xs tw-text-gray-500 tw-text-center">
          {t('messaging_rules.upgrade_modal.description')}
        </p>
        <div className="tw-flex tw-gap-3 tw-w-full">
          <ButtonMC
            text={t('messaging_rules.upgrade_modal.close')}
            variant="GRAY"
            outlined
            className="tw-flex-1"
            onClick={close}
            type="button"
          />
          <ButtonMC
            text={t('messaging_rules.upgrade_modal.button')}
            className="tw-flex-1"
            onClick={goToPlans}
          />
        </div>
      </div>
    </RightModalLayout>
  );
};

export default MessagingRuleUpgradeModal;
